import axios from "@/lib/axios";

export const checkUrlStatus = (url: string) =>
  axios.get(`/v1/check-url-status`, { params: { url } });
